import { Button, Card, CircularProgress, Grid, InputLabel, MenuItem, Select, Tooltip } from '@material-ui/core';
import { InfoOutlined } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';

import { RichTextEditor } from '../../../../../matx';
import { UploadImage } from '../../../../components';
import { addDataMedia, getKategoriMedia } from '../../../../redux/actions/MediaActions';

const TambahData = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [submit, setSubmit] = useState(false);
    const {kategori} = useSelector(({media}) => media)
    const [params, setParams] = useState({
        thumbnail: '',
        thumbnail_preview: '',
        title_id: '',
        title_en: '',
        desc_id: '',
        desc_en: '',
        cat_code: '',
        meta_title_id: '',
        meta_title_en: '',
        meta_desc_id: '',
        meta_desc_en: '',
    });
    useEffect(() => {
      dispatch(getKategoriMedia({paginate: false}))
    }, [dispatch])
    
    const handleChange = ({ target: { value, name } }) => {
        setParams((pref) => ({
            ...pref,
            [name]: value
        }));
    };
    const handleFormSubmit = () => {
        setSubmit(true);
        addDataMedia(params)
            .then(() => {
                showAlert('Data berhasil disimpan', true);
                setSubmit(false);
            })
            .catch((err) => {
                let error = err?.response?.data;
                showAlert(
                    Array.isArray(error?.data)
                        ? error?.data[0]
                        : 'Gagal menyimpan data, coba beberapa saat lagi',
                    false
                );
                setSubmit(false);
            });
    };
    const showAlert = (text, success) => {
        Swal.fire({
            title: success ? 'Berhasil' : 'Oopss!',
            text: text,
            imageUrl: `/assets/images/icons/${
                success ? 'ic_success' : 'ic_error'
            }.svg`,
            imageWidth: 92,
            imageHeight: 92,
            confirmButtonText: 'Ok',
            confirmButtonColor: '#0083E2'
        }).then((res) => {
            if (res.isConfirmed && success) {
                history.goBack();
            }
        });
    };
    const handleChangeFoto = (file, path) => {
        setParams((pref) => ({
            ...pref,
            thumbnail: file,
            thumbnail_preview: path
        }));
    };
    return (
        <div className="m-sm-30">
            <Grid container spacing={4} justifyContent="center">
                <Grid item xs={11} md={12}>
                    <h3 className="fw-bold m-0">Tambah Data</h3>
                </Grid>
                <Grid item xs={11} md={12}>
                    <Card elevation={0} className="py-5 px-6 border-radius-0 ">
                        <ValidatorForm
                            onSubmit={handleFormSubmit}
                            className="w-full"
                        >
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <UploadImage
                                        uploadFoto={handleChangeFoto}
                                        label="Unggah Foto"
                                        preview={
                                            params?.thumbnail_preview
                                        }
                                        noCrop={true}
                                        required={true}
                                        note={[
                                            'Format PNG, WEBP dan JPG diperbolehkan',
                                        ]}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <InputLabel
                                        htmlFor="title_id"
                                        className="mb-4"
                                    >
                                        Judul [ID]{' '}
                                        <span className="text-danger">*</span>
                                        <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website" placement='top-start' arrow>
                                            <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                        </Tooltip>
                                    </InputLabel>
                                    <TextValidator
                                        id="title_id"
                                        placeholder="Judul"
                                        className="w-full"
                                        variant="outlined"
                                        onChange={handleChange}
                                        type="text"
                                        name="title_id"
                                        value={params.title_id || ''}
                                        validators={['required']}
                                        errorMessages={[
                                            'Masukkan Judul terlebih dahulu'
                                        ]}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <InputLabel
                                        htmlFor="title_en"
                                        className="mb-4"
                                    >
                                        Judul [EN]{' '}
                                        <span className="text-danger">*</span>
                                        <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website" placement='top-start' arrow>
                                            <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                        </Tooltip>
                                    </InputLabel>
                                    <TextValidator
                                        id="title_en"
                                        placeholder="Judul"
                                        className="w-full"
                                        variant="outlined"
                                        onChange={handleChange}
                                        type="text"
                                        name="title_en"
                                        value={params.title_en || ''}
                                        validators={['required']}
                                        errorMessages={[
                                            'Masukkan Judul terlebih dahulu'
                                        ]}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <InputLabel
                                        htmlFor="meta_title_id"
                                        className="mb-4"
                                    >
                                        Meta Judul [ID]{' '}
                                        <span className="text-danger">*</span>
                                        <Tooltip title="Teks Akan digunakan untuk seo saat pengguna menggunakan bahasa Indonesia pada website" placement='top-start' arrow>
                                            <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                        </Tooltip>
                                    </InputLabel>
                                    <TextValidator
                                        id="meta_title_id"
                                        placeholder="Meta judul"
                                        className="w-full"
                                        variant="outlined"
                                        onChange={handleChange}
                                        type="text"
                                        name="meta_title_id"
                                        value={params.meta_title_id || ''}
                                        validators={['required']}
                                        errorMessages={[
                                            'Masukkan Meta judul terlebih dahulu'
                                        ]}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <InputLabel
                                        htmlFor="meta_title_en"
                                        className="mb-4"
                                    >
                                        Meta Judul [EN]{' '}
                                        <span className="text-danger">*</span>
                                        <Tooltip title="Teks Akan digunakan untuk seo saat pengguna menggunakan bahasa Inggris pada website" placement='top-start' arrow>
                                            <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                        </Tooltip>
                                    </InputLabel>
                                    <TextValidator
                                        id="meta_title_en"
                                        placeholder="Meta judul"
                                        className="w-full"
                                        variant="outlined"
                                        onChange={handleChange}
                                        type="text"
                                        name="meta_title_en"
                                        value={params.meta_title_en || ''}
                                        validators={['required']}
                                        errorMessages={[
                                            'Masukkan Meta judul terlebih dahulu'
                                        ]}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <InputLabel
                                        htmlFor="meta_desc_id"
                                        className="mb-4"
                                    >
                                        Meta Deskripsi [ID]{' '}
                                        <span className="text-danger">*</span>
                                        <Tooltip title="Teks Akan digunakan untuk seo saat pengguna menggunakan bahasa Indonesia pada website" placement='top-start' arrow>
                                            <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                        </Tooltip>
                                    </InputLabel>
                                    <TextValidator
                                        id="meta_desc_id"
                                        placeholder="Deskripsi"
                                        className="w-full"
                                        variant="outlined"
                                        onChange={handleChange}
                                        type="text"
                                        name="meta_desc_id"
                                        value={params.meta_desc_id || ''}
                                        validators={['required']}
                                        multiline
                                        maxRows={15}
                                        errorMessages={[
                                            'Masukkan Deskripsi terlebih dahulu'
                                        ]}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <InputLabel
                                        htmlFor="meta_desc_en"
                                        className="mb-4"
                                    >
                                        Meta Deskripsi [EN]{' '}
                                        <span className="text-danger">*</span>
                                        <Tooltip title="Teks Akan digunakan untuk seo saat pengguna menggunakan bahasa Inggris pada website" placement='top-start' arrow>
                                            <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                        </Tooltip>
                                    </InputLabel>
                                    <TextValidator
                                        id="meta_desc_en"
                                        placeholder="Deskripsi"
                                        className="w-full"
                                        variant="outlined"
                                        onChange={handleChange}
                                        type="text"
                                        name="meta_desc_en"
                                        value={params.meta_desc_en || ''}
                                        validators={['required']}
                                        multiline
                                        maxRows={15}
                                        errorMessages={[
                                            'Masukkan Deskripsi terlebih dahulu'
                                        ]}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <InputLabel htmlFor="cat_code" className="mb-4">
                                        Kategori{' '}
                                        <span className="text-danger">*</span>
                                    </InputLabel>
                                    <Select
                                        labelId="cat_code"
                                        value={params.cat_code}
                                        onChange={handleChange}
                                        variant="outlined"
                                        className="w-full"
                                        name="cat_code"
                                        displayEmpty
                                    >
                                        <MenuItem value="" selected disabled>
                                            Pilih Kategori
                                        </MenuItem>
                                        {kategori?.map((item) => (
                                            <MenuItem
                                                value={item?.cat_code}
                                                key={item?.cat_code}
                                            >
                                                {item?.cat_name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </Grid>
                                <Grid item xs={12}>
                                    <InputLabel
                                        htmlFor="desc_id"
                                        className="mb-4"
                                    >
                                        Berita [ID]{' '}
                                        <span className="text-danger">*</span>
                                        <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website" placement='top-start' arrow>
                                            <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                        </Tooltip>
                                    </InputLabel>
                                    <RichTextEditor handleContentChange={(content) => setParams(pref => ({...pref, desc_id: content}))} content={params.desc_id} placeholder="Ketik berita disini" />
                                </Grid>
                                <Grid item xs={12}>
                                    <InputLabel
                                        htmlFor="desc_en"
                                        className="mb-4"
                                    >
                                        Berita [EN]{' '}
                                        <span className="text-danger">*</span>
                                        <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website" placement='top-start' arrow>
                                            <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                        </Tooltip>
                                    </InputLabel>
                                    <RichTextEditor handleContentChange={(content) => setParams(pref => ({...pref, desc_en: content}))} content={params.desc_en} placeholder="Ketik berita disini" />
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid
                                        container
                                        spacing={2}
                                        justifyContent="flex-end"
                                        className="flex-column-reverse flex-md-row"
                                    >
                                        <Grid item xs={12} md={2}>
                                            <Button
                                                color="primary"
                                                className="text-primary w-full radius-6 text-capitalize py-2"
                                                disableElevation
                                                disabled={submit}
                                                onClick={() => history.goBack()}
                                            >
                                                Batal
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <Button
                                                type="submit"
                                                variant="contained"
                                                color="primary"
                                                className="text-white w-full radius-6 text-capitalize py-2"
                                                disableElevation
                                                disabled={submit}
                                            >
                                                {submit ? (
                                                    <CircularProgress
                                                        color="primary"
                                                        size={25}
                                                    />
                                                ) : (
                                                    'Simpan'
                                                )}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </ValidatorForm>
                    </Card>
                </Grid>
            </Grid>
        </div>
    );
};

export default TambahData;
